import { getFiles } from "apis/controllers/files";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { getDisbursement } from "src/apis/controllers/disbursements";
import { useLookup } from "src/context/lookupContext";
import { useLoading } from "src/hooks/useLoading";

const useDisbursementDetails = () => {
  const [data, setData] = useState(null);
  const [files, setFiles] = useState(null);
  const { id } = useParams();
  const { setLoading } = useLoading();
  const [succeeded, setSucceeded] = useState(false);
  const form = useForm();
  const expensesForm = useForm();
  const { setLookups } = useLookup();

  const resetForm = async () => {
    try {
      setLoading(true);
      const res = await getDisbursement(id);
      const resFiles = await getFiles({
        DataKey: "MHD_Disbursement",
        DataValue: res?.data?.disbursement?.typeId,
        RecordId: null,
        RecordGuid: id,
        ProjectTableId: 13,
      });
      setData(res?.data);
      setFiles(resFiles?.data);
      form.reset(res?.data?.disbursement);
    } catch {}
    setLoading(false);
  };

  const fetchDisbursement = async () => {
    try {
      setLoading(true);

      setData(null);
      setFiles(null);
      setSucceeded(false);
      const res = await getDisbursement(id);
      const resFiles = await getFiles({
        DataKey: "MHD_Disbursement",
        DataValue: res?.data?.disbursement?.typeId,
        RecordId: null,
        RecordGuid: id,
        ProjectTableId: 13,
      });
      setFiles(resFiles?.data);
      form.reset(res?.data?.disbursement);
      setData(res?.data);
      setLookups(res?.data?.lookups);
      setSucceeded(res?.succeeded);
    } catch {}
    setLoading(false);
  };

  useEffect(() => {
    fetchDisbursement();
  }, []);

  return {
    form,
    expensesForm,
    data,
    succeeded,
    files,
    fetchDisbursement,
    resetForm,
  };
};

export default useDisbursementDetails;
